import { useBoundStore } from '@Store/useBoundStore';
import { DNB_PARTNER_IDS } from '@Types/consts';
import type { DnbPartnerIds } from '@Types/consts';

/**
 * True when the app is running inside a D&B partner iframe (embedded).
 * Used to strip the welcome page down to a centered, panel-less sign-up form.
 */
export const useIsDnbEmbedded = () => {
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());
  const partnerId = useBoundStore((state) => state.customer.partnerId);

  return isEmbedded && DNB_PARTNER_IDS.includes(partnerId as DnbPartnerIds);
};
